import { render, staticRenderFns } from "./VacancySkills.htm?vue&type=template&id=67653a61&scoped=true&"
import script from "./VacancySkills.ts?vue&type=script&lang=js&"
export * from "./VacancySkills.ts?vue&type=script&lang=js&"
import style0 from "./VacancySkills.scss?vue&type=style&index=0&id=67653a61&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67653a61",
  null
  
)

export default component.exports